import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'mg-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  @Input() loading: boolean = true;
  @Input() text!: string;


  constructor() { }

  ngOnInit(): void {
  }

}
